export default "__VITE_ASSET__Dw3N12my__"